<template>
  <div>
    <div id="nomalInfoContainer">
      <b-form @submit="onSubmit">
        <b-form-group>
          下次聯絡時間
          <datetime
            type="datetime"
            v-model="form.tackingDate"
            input-id="tackingDateInput"
            :minute-step="10"
            :min-datetime="formatDate(new Date(), 'yyyy-MM-dd')"
            :max-datetime="formatDate(new Date().addDays(salestraceMaxDay), 'yyyy-MM-dd')"
          ></datetime>
        </b-form-group>
        <b-form-group>
          <b-form-textarea
            v-model="form.tackingDetail"
            :state="form.tackingDetail.length > 1"
            size="sm"
            placeholder="請輸入備註"
            required
          ></b-form-textarea>
        </b-form-group>
        <b-form-group>
          <b-form-radio v-model="form.assignType" name="some-radios" value="A">指定業務</b-form-radio>
          <v-select v-model="form.salseObj" :options="salseOptions" style="margin: 6px 0 12px;"></v-select>
          <b-form-radio
            v-show="showDlgsChannel"
            v-model="form.assignType"
            name="some-radios"
            value="B"
          >系統分配</b-form-radio>
          <b-form-select
            v-show="showDlgsChannel"
            v-model="form.dlgsChannel"
            size="sm"
            :state="dlgsChannelState"
            :required="dlgsChannelRequired"
            :options="form.dlgsChannelOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group>
          <b-button type="submit" variant="danger" block>送出</b-button>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
import { LeadHandler } from "@/handler/LeadHandler.js";
import store_tackingLead from "@/vuex/store_tackingLead.js";
import http from "../../http.js";
import qs from "qs";
export default {
  props: ["leadSn", "socialLeadId", "tutorChatToken"],
  data() {
    return {
      showDlgsChannel: false,
      salseOptions: [],
      salestraceMaxDay: 10,
      form: {
        tackingDate: "",
        tackingDetail: "",
        assignType: "A",
        assignValue: "",
        salseObj: "",
        dlgsChannel: null,
        dlgsChannelOptions: [{ value: null, text: "請選擇" }]
      },
      careSn: ""
    };
  },
  created() {
    //在電腦版SCRM首頁剛載入時不會帶入兩個參數。
    if (this.leadSn === undefined && this.socialLeadId === undefined) {
      return;
    }

    //設定預設時間為明天
    this.form.tackingDate = this.formatDate(
      new Date().addDays(1),
      "yyyy-MM-dd"
    );

    //先從store裡面取出再洗掉，才能正確的觸發followUP。
    this.careSn = store_tackingLead.state.careSn;
    store_tackingLead.dispatch("setCareSn", "");

    http
      .post(
        "/SCRMApp/GetCustomerSimpleInfo",
        qs.stringify({
          SocialLeadId: this.socialLeadId,
          LeadSn: this.leadSn,
          tutorChatToken: this.tutorChatToken
        })
      )
      .then(response => {
        var careTypes = response.data.Result.model.IsCustomer;
        this.salestraceMaxDay =
          response.data.Result.salestraceLimit.salestraceMaxDay;
        if (
          !(
            this.leadSn === "" ||
            this.leadSn === null ||
            this.leadSn === undefined
          ) &&
          careTypes === 0
        ) {
          this.showDlgsChannel = true;
          var leadInfo = LeadHandler.GetLead(this.leadSn, this.tutorChatToken);
          var getLeadSourceResult = LeadHandler.getLeadSourceOptions(
            leadInfo.brand,
            this.tutorChatToken
          );
          this.form.dlgsChannelOptions = getLeadSourceResult.Options;
          this.form.dlgsChannel = getLeadSourceResult.DefaultValue;
        }
      })
      .catch(function(error) {
        alert(error);
        window.location.href = "/#/Error";
      });

    http
      .post(
        "/SCRMApp/GetStaffListByPermission",
        qs.stringify({
          tutorChatToken: this.tutorChatToken
        })
      )
      .then(response => {
        this.salseOptions = response.data.Result.ListStaffProfileInsViewModel;
        this.form.salseObj = response.data.Result.Default;
      })
      .catch(function(error) {
        alert(error);
        window.location.href = "/#/Error";
      });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      //因為下拉套件沒有好的Required動作，自己實作。
      if (this.form.assignType == "A" && this.form.salseObj === null) {
        this.makeToast("warning", "警告！", "請選擇指定業務。");
        return;
      }
      if(this.convertUTCDateToLocalDate(this.form.tackingDate) < this.convertUTCDateToLocalDate(new Date())){
        this.makeToast("warning", "警告！", "選擇的時間小於現在時間。");
        return;
      }
      switch (this.form.assignType) {
        case "A":
          this.form.assignValue = this.form.salseObj.StaffSn;
          break;
        case "B":
          this.form.assignValue = this.form.dlgsChannel;
          break;
      }

      http
        .post(
          "/SCRMApp/TackingLead",
          qs.stringify({
            tackingLeadModel: {
              TackingDate: this.form.tackingDate,
              TackingDetail: this.form.tackingDetail,
              AssignType: this.form.assignType,
              AssignValue: this.form.assignValue,
              SocialLeadId: this.socialLeadId,
              LeadSn: this.leadSn,
              CareSn: this.careSn,
              TutorChatToken: this.tutorChatToken
            }
          })
        )
        .then(response => {
          if (!response.data.Success) {
            alert("後續追蹤失敗，請聯絡資訊人員。");
          } else {
            this.makeToast("success", "成功", "成功追蹤。");
          }
          store_tackingLead.dispatch("switchToListPage");
        })
        .catch(function(error) {
          alert(error);
          window.location.href = "/#/Error";
        });
    },
    minDay: function() {
      return (
        new Date().getFullYear() +
        "-" +
        this.padLeft((new Date().getMonth() + 1).toString(), 2) +
        "-" +
        this.padLeft(new Date().getDate().toString(), 2)
      );
    },
    maxDay: function() {
      var maxDay = new Date(
        new Date().setDate(new Date().getDate() + this.salestraceMaxDay)
      );
      return (
        maxDay.getFullYear() +
        "-" +
        this.padLeft((maxDay.getMonth() + 1).toString(), 2) +
        "-" +
        this.padLeft(maxDay.getDate().toString(), 2)
      );
    },
    makeToast(variant, title, content) {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      });
    }
  },
  computed: {
    //null為沒有紅綠框 false為顯示紅框 true為顯示綠框
    dlgsChannelState() {
      if (this.form.assignType == "A") {
        return null;
      }

      return this.form.assignType == "B" && this.form.dlgsChannel != null;
    },
    dlgsChannelRequired() {
      if (this.form.assignType == "B") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
#tackingDateInput {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  padding: 0.25rem 0.5rem;
}

#tackingDateInput,
.custom-select,
.form-control-sm {
  border-color: #e8e8e8;
  font-size: 15px;
  padding: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 6px 0 12px;
}

.vdatetime-time-picker__item--selected,
.vdatetime-year-picker__item--selected,
.vdatetime-month-picker__item--selected {
  color: #b20404 !important;
}

.form-control:focus {
  border-color: #e8e8e8;
}
.form-control.is-invalid {
  min-height: calc(1.5em + 0.75rem + 2px);
}
.custom-select {
  line-height: 0.9;
}
.form-control.is-invalid {
  border-color: #d27f7f;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background: #b20404 !important;
  border-color: #b20404 !important;
}

.custom-select:focus {
  box-shadow: none;
  border-color: #e8e8e8;
}

.form-control.is-valid:focus,
.form-control.is-invalid:focus,
.custom-select.is-invalid:focus,
.form-control:focus {
  box-shadow: none;
}

.fixed-bottom {
  z-index: 3;
}

.form-group {
  font-size: 15px;
  margin-bottom: 0;
}
</style>>

<style scoped>
#nomalInfoContainer .btn-danger {
  background-color: #b20404;
  border-color: #b20404;
}
#nomalInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/TackingLead.vue